import { jsx as e } from "react/jsx-runtime";
import { DefaultBadgeMonoLogo as n } from "../default/default/badge/mono.js";
import { DefaultBadgeNegativeLogo as f } from "../default/default/badge/negative.js";
import { DefaultBadgePositiveLogo as g } from "../default/default/badge/positive.js";
import { DefaultSymbolPositiveLogo as a } from "../default/default/symbol/positive.js";
import { DefaultSymbolMonoLogo as u } from "../default/default/symbol/mono.js";
import { DefaultSymbolNegativeLogo as l } from "../default/default/symbol/negative.js";
import { DefaultBrandMarkMonoLogo as v } from "../default/default/brand-mark/mono.js";
import { DefaultBrandMarkNegativeLogo as d } from "../default/default/brand-mark/negative.js";
import { DefaultBrandMarkPositiveLogo as i } from "../default/default/brand-mark/positive.js";
const M = (o, t) => ({
  positive: /* @__PURE__ */ e(i, { ...o }),
  negative: /* @__PURE__ */ e(d, { ...o }),
  mono: /* @__PURE__ */ e(v, { ...o })
})[t] || /* @__PURE__ */ e(i, { ...o }), s = (o, t) => ({
  positive: /* @__PURE__ */ e(a, { ...o }),
  negative: /* @__PURE__ */ e(l, { ...o }),
  mono: /* @__PURE__ */ e(u, { ...o })
})[t] || /* @__PURE__ */ e(a, { ...o }), c = (o, t) => ({
  positive: /* @__PURE__ */ e(g, { ...o }),
  negative: /* @__PURE__ */ e(f, { ...o }),
  mono: /* @__PURE__ */ e(n, { ...o })
})[t] || /* @__PURE__ */ e(a, { ...o });
function x(o) {
  const { variant: t = "positive", type: m = "brand-mark", ...r } = o;
  switch (m) {
    case "brand-mark":
      return M(r, t);
    case "symbol":
      return s(r, t);
    case "badge":
      return c(r, t);
  }
}
export {
  x as BrandMark
};
//# sourceMappingURL=brand-mark.component.js.map
